import ChatFilterMenu from 'container/components/ChatFilterMenu/ChatFilterMenu';
import React from 'react';

import { useSelector, useDispatch } from 'react-redux';

function Chats({ setSignUpModal }) {
  const isLoggedIn = localStorage.getItem('token');
  const dispatch = useDispatch();
  const isOpen = useSelector(state => state.utils.isLeftSideBarOpen);
  const conversations = useSelector(state => state.chat.conversations);

  // const handleChangeFilter = (filter) => {
  //   dispatch.chat.setTimeFilter(filter);
  // };

  return (
    <div className='chats-container' style={{ alignItems: 'center' }}>
      <div className='left-side'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='30'
          height='30'
          viewBox='0 0 30 30'
          fill='none'
          style={{
            width: isOpen ? '30px' : '40px',
            height: isOpen ? '30px' : '40px',
          }}
          onClick={() => dispatch.utils.setLeftSideBar(true)}
        >
          <rect width='30' height='30' rx='8' fill='#74AA9C' />
          <path
            d='M19.874 14.1417C19.8163 10.878 17.1525 8.25 13.875 8.25C10.5613 8.25 7.875 10.9363 7.875 14.25C7.875 15.8138 8.47324 17.2378 9.45334 18.3058L9.00391 21.0096L11.6719 19.8637C12.8474 20.2546 13.9567 20.3523 15 20.1568'
            stroke='white'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M20.5357 20.9735C19.8801 21.4613 19.0675 21.75 18.1875 21.75C16.0129 21.75 14.25 19.9871 14.25 17.8125C14.25 15.6379 16.0129 13.875 18.1875 13.875C20.3621 13.875 22.125 15.6379 22.125 17.8125C22.125 18.4124 21.9909 18.981 21.7509 19.4898'
            stroke='white'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M21.7509 19.4898L22.125 21.75L20.5356 20.9735'
            stroke='white'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.5156 12.8251C12.5156 13.2946 12.1379 13.6751 11.6719 13.6751C11.2059 13.6751 10.8281 13.2946 10.8281 12.8251C10.8281 12.3557 11.2059 11.9751 11.6719 11.9751C12.1379 11.9751 12.5156 12.3557 12.5156 12.8251ZM15.8906 12.8251C15.8906 13.2946 15.5128 13.6751 15.0469 13.6751C14.5809 13.6751 14.2031 13.2946 14.2031 12.8251C14.2031 12.3557 14.5809 11.9751 15.0469 11.9751C15.5128 11.9751 15.8906 12.3557 15.8906 12.8251ZM19.3828 17.5499C19.0333 17.5499 18.75 17.2645 18.75 16.9124C18.75 16.5603 19.0333 16.2749 19.3828 16.2749C19.7323 16.2749 20.0156 16.5603 20.0156 16.9124C20.0156 17.2645 19.7323 17.5499 19.3828 17.5499ZM16.2188 16.9124C16.2188 17.2645 16.5021 17.5499 16.8516 17.5499C17.2011 17.5499 17.4844 17.2645 17.4844 16.9124C17.4844 16.5603 17.2011 16.2749 16.8516 16.2749C16.5021 16.2749 16.2188 16.5603 16.2188 16.9124Z'
            fill='white'
          />
        </svg>
        {isOpen && (
          <>
            <h1 className='chat-heading'>Chats</h1>
            {isLoggedIn && (
              <div className='eye-circle'>{conversations.length}</div>
            )}
          </>
        )}
      </div>
      {isOpen && !isLoggedIn && (
        <div onClick={() => setSignUpModal(true)} style={{ cursor: 'pointer' }}>
          <p
            style={{
              color: '#FF434E',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '18px',
              margin: '0px',
            }}
          >
            Sign up to save your chats
          </p>
        </div>
      )}
      {isOpen && (
        <div className='custom-select'>
          <ChatFilterMenu />
        </div>
      )}
    </div>
  );
}

export default Chats;
